export const createTrailerConfig = (selectOptions) => {
  return [
    {
      step_title: 'Name',
      form_title: 'New Trailer',
      section: [
        {
          name: 'trailer_number',
          placeholder: 'Enter a Trailer Number',
          input: 'input',
          precision: 0,
          rules: [
            {
              required: true,
              message: 'Trailer Number is required',
            },
          ],
        },
        {
          name: 'configuration',
          input: 'select',
          options: selectOptions?.configurationOptions,
          placeholder: 'Select a configuration',
          rules: [
            {
              required: true,
              message: 'Configuration is required',
            },
          ],
        },
        {
          name: 'depot',
          input: 'select',
          options: selectOptions.depotOptions,
          placeholder: 'Select a depot',
          rules: [
            {
              required: true,
              message: 'Depot is required',
            },
          ],
        },
        {
          name: 'make',
          input: 'input',
          placeholder: 'Enter make',
          rules: [
            {
              required: true,
              message: 'Make required',
            },
          ],
        },
        {
          name: 'model',
          input: 'input',
          placeholder: 'Enter model',
          rules: [
            {
              required: true,
              message: 'Model required',
            },
          ],
        },
        {
          name: 'weight',
          input: 'inputNumber',
          min: 0,
          placeholder: 'Enter weight',
          rules: [
            {
              required: true,
              message: 'Weight required',
            },
          ],
        },
      ],
    },
  ]
}
